module.exports = __webpack_public_path__ + "static/media/7.b4171e7b.png";